import React from 'react';

function BonusPointsEmpty() {
    return (
        <div className="md:px-0 px-5">
            <div>
                <p className="text-xl dark:text-textDarkLightGray text-textLight
                                      flex flex-row justify-between font-semibold mb-8">
                    🪙 Бонусы OSHISHA
                </p>

                <p className="text-lg dark:text-textDarkLightGray text-textLight
                                      flex flex-row justify-between font-semibold mb-8">
                    Участвуйте в бонусной программе — получайте баллы за каждый заказ и обменивайте их на подарки, мерч и скидки.
                </p>

                <div className="mb-8">
                    <p className="text-lg dark:text-textDarkLightGray text-textLight
                                      flex flex-row justify-between font-semibold mb-4">
                        🎁 Что вы получаете:
                    </p>
                    <ul className="list-disc ms-12">
                        <li>
                            <span className="font-semibold">Бонусы за каждую покупку </span>
                            — от 1% до 10% в зависимости от категории и вашего статуса
                        </li>
                        <li>
                            <span className="font-semibold">Подарки за баллы </span>
                            — в специальном разделе «Мерч за бонусы»
                        </li>
                        <li>
                            <span className="font-semibold">Бонусы на день рождения</span>
                        </li>
                        <li>
                            <span className="font-semibold">Подарки за друга </span>
                            — пригласите друга и получите до 1 000 бонусов
                        </li>
                    </ul>
                </div>

                <div className="mb-8">
                    <p className="text-lg dark:text-textDarkLightGray text-textLight
                                      flex flex-row justify-between font-semibold mb-4">
                        📈 Как это работает:
                    </p>
                    <ol className="list-decimal ms-12">
                        <li>
                            <span className="font-semibold">Делайте заказы </span>
                            на сайте — бонусы начисляются автоматически после получения заказа.
                        </li>
                        <li>
                            <span className="font-semibold">Копите баллы </span>
                            — срок действия бонусов: 180 дней.
                        </li>
                        <li>
                            <span className="font-semibold">Используйте бонусы </span>
                            — оплатите до 30% следующего заказа или закажите подарки.
                        </li>
                    </ol>
                </div>

                <p className="text-lg dark:text-textDarkLightGray text-textLight
                                      flex flex-row justify-between font-semibold mb-8">
                    Если у вас не работает и не начисляются бонусы то свяжитесь со своим менеджером
                </p>


            </div>
        </div>
    );
}

export default BonusPointsEmpty;